<script lang="ts" setup>
import { NConfigProvider } from 'naive-ui'
import { zhCN, dateZhCN } from 'naive-ui'
import { theme } from '~~/theme'
</script>

<template>
  <div class="m-layout myz-layout myz-bg-secondary">
    <TopBar />
    <!-- <RTopbar /> -->
    <div class="m-layout-page container">
      <slot />
    </div>
    <!-- <RFooter /> -->
    <MFooter />
    <MOpenAPP />
  </div>
</template>

<style lang="scss" scoped>
@media screen and (min-width: 600px) {
  .m-layout {
    &--index {
      background-color: #fff;
    }
    &-page {
      padding-top: 92px;
      min-width: 460px;
      //max-width: min(80%, 1920px);
      position: relative;
      margin: 0 auto;
    }
  }
}

@media screen and (max-width: 600px) {
  .m-layout {
    &-page {
      padding-top: 72px;
      width: 100%;
      min-width: 0;
    }
  }
}
</style>
